import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import InitialContext from 'state/static-data/InitialContext';
import { ApplicationState } from 'state/store/configureStore';
import { TranslatorStringId, TranslatorStringsState } from 'state/types';
import { StringTranslator } from 'utils';

export const FEATURE_NAME = 'translator-strings';

const initStrings = () => {
    const strings = InitialContext.getStrings();
    return new StringTranslator(strings);
}

export const INITIAL_STATE: TranslatorStringsState = {
    stringTranslator: initStrings(),
};

const slice = createSlice({
    name: FEATURE_NAME,
    initialState: INITIAL_STATE,
    reducers: {
        // Add this upsert method incase need to update translator string by ajax call dynamically.
        upsertTranslatorStrings(state, action: PayloadAction<Record<TranslatorStringId, string>>) {
            const updatedStrings = Object.assign({}, state.stringTranslator.strings, action.payload);
            state.stringTranslator = new StringTranslator(updatedStrings);
        },
    },
});

export const { upsertTranslatorStrings } = slice.actions;

export default slice.reducer;

export const selectStringTranslator = (state: ApplicationState): StringTranslator => state.translatorStringsState.stringTranslator;